import "es6-shim";
import { Div } from "../../../common/ui/widgets";
import {
  GRAPH_DATA_TYPES,
  TITLES_V_A_HZ,
  TITLES_AP,
  TITLES_PO,
  TITLES_THD_THC,
} from "../../3540/helpers/constants";
import {
  GRAPH_3540_INTERVAL_INFO,
  GRAPH_3540_SAMPLING_TIME,
} from "./constants";
//--------------------------------------generic functions--------------------------//

//---------------------------------------validations------------------------------//
export const isEmptyObj = (obj) => {
  return Object.getOwnPropertyNames(obj).length === 0 || obj.length === 0;
};

//---------------------------------------utility----------------------------------//

export const getMin = (data) =>
  data && data.reduce((min, n) => (n < min ? n : min));

export const getMax = (data) =>
  data && data.reduce((max, n) => (n > max ? n : max));

export const getMinObj = (data, key) =>
  data.reduce((prev, cur) => (prev[key] < cur[key] ? prev : cur));

export const getMaxObj = (data, key) =>
  data.reduce((prev, cur) => (prev[key] > cur[key] ? prev : cur));

export const getPrecision = (num, precision) => {
  precision = Math.pow(10, precision);
  return Math.round(num * precision) / precision;
};
export const getLatest = (data) =>
  data.length ? data[data.length - 1] : "undefined";

export const getPluckedData = (data, key) =>
  data && data.map((value) => value[key]);
export const getFilteredData = (data, key) =>
  data.filter((value) => value[key] === true);

export const getSortedData = (data, key) => {
  const arr = data.map((item) => {
    item.values.sort((a, b) => a[key] - b[key]);
    return item;
  });
  return arr;
};

export const getAverageData = (data) =>
  data.reduce((p, c) => p + c, 0) / data.length;

export const getExtremeData = (data, key) => {
  let keyArray = getPluckedData(data, key);
  let min = getMin(keyArray);
  let max = getMax(keyArray);
  return { min, max };
};

export const debounce = (func, delay) => {
  let inDebounce;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

export const getElementContentWidth = (element) => {
  var styles = window.getComputedStyle(element);
  var padding =
    parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
  return element.clientWidth - padding;
};

export const updateObj = (from, to) => {
  return { from: from, to: to };
};

export const getMinMaxRange = (start, end, step) => {
  const divider = (end - start) / step;
  const rangeObj = Array.from(
    Array.from(Array(Math.ceil((end - start) / divider)).keys()),
    (x) => start + x * divider
  );
  rangeObj.push(end);
  return rangeObj;
};

export const currentWindowSize = () => {
  let body = document.getElementsByTagName("body")[0];
  return window.innerWidth || body.clientWidth;
};

export const isDeviceLoad = () => {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
};

export const viewPortSize = {
  mobile: 600,
  tabletPortrait: 768,
  tabletLandscape: 1024,
  desktopSmall: 1280,
  desktopBig: 1920,
};

export const extractAxis = (data, name) =>
  data.filter((item) => item.name === name);

export const extract3540Axis = (data, name) =>
  data.filter((item) => item.dataType === name);

export const filterAxis = (data, name) =>
  data.filter((item) => item.name !== name);

export const filter3540Axis = (data, name) =>
  data.filter((item) => !item.name.includes(name));

export const getDisplayDate = (time) => {
  let date = new Date(time);
  let month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  let year = String(date.getFullYear()).slice(-2);
  return (
    month +
    "/" +
    day +
    "/" +
    year +
    " | " +
    date.getHours() +
    ":" +
    date.getMinutes() +
    ":" +
    (date.getSeconds() ? date.getSeconds() : "00")
  );
};

export const getLocaleDisplayDate = (time) => {
  let captureDateTime = new Date(time);
  let DateTimeString = captureDateTime.toLocaleString();
  let [captureDate, captureTime] = DateTimeString.split(",");
  return captureDate + captureTime;
};
export const getToolTipInfo = (obj) => {
  if (obj.point.triggeredValue != null) {
    return (
      "<Div>" +
      (obj.point.triggeredValue
        ? obj.point.triggeredAxis
          ? "Triggered on " +
            obj.point.triggeredAxis.toUpperCase() +
            " Axis : " +
            obj.point.triggeredValue
          : obj.point.triggeredValue
        : "") +
      "</Div ><Div>" +
      "</Div>"
    );
  } else {
    return obj.point.OLValue ? obj.point.OLValue : obj.y + " " + obj.point.unit;
  }
};

export const alarmTooltipDataType = (dataType) => {
  switch (dataType) {
    case GRAPH_DATA_TYPES.Current:
      return TITLES_V_A_HZ.CURRENT;
    case GRAPH_DATA_TYPES.Voltage:
      return TITLES_V_A_HZ.VOLTAGE;
    case GRAPH_DATA_TYPES.Frequency:
      return TITLES_V_A_HZ.FREQUENCY;
    case GRAPH_DATA_TYPES.ActivePower:
      return TITLES_AP.ACTIVE_POWER;
    case GRAPH_DATA_TYPES.PowerFactor:
      return TITLES_AP.POWER_FACTOR;
    case GRAPH_DATA_TYPES.ApparentPower:
      return TITLES_PO.APPARENT_POWER;
    case GRAPH_DATA_TYPES.NonActivePower:
      return TITLES_PO.NON_ACTIVE_POWER;
    case GRAPH_DATA_TYPES.THDV:
      return TITLES_THD_THC.THD_VOLTAGE;
    case GRAPH_DATA_TYPES.THDC:
      return TITLES_THD_THC.THD_CURRENT;
    case GRAPH_DATA_TYPES.HarmonicContentCurrent:
      return TITLES_THD_THC.HARMONIC_CONTENT_CURRENT;
    default:
      return dataType;
  }
};

export const get3540SamplingTime = (timeInterval) => {
  if (timeInterval > GRAPH_3540_INTERVAL_INFO.oneMonth) {
    return GRAPH_3540_SAMPLING_TIME.all;
  } else if (GRAPH_3540_INTERVAL_INFO.oneWeek < timeInterval) {
    return GRAPH_3540_SAMPLING_TIME.oneMonth;
  } else if (GRAPH_3540_INTERVAL_INFO.oneDay < timeInterval) {
    return GRAPH_3540_SAMPLING_TIME.oneWeek;
  } else if (GRAPH_3540_INTERVAL_INFO.twelveHour < timeInterval) {
    return GRAPH_3540_SAMPLING_TIME.oneDay;
  } else if (GRAPH_3540_INTERVAL_INFO.oneHour < timeInterval) {
    return GRAPH_3540_SAMPLING_TIME.twelveHour;
  } else {
    return GRAPH_3540_SAMPLING_TIME.oneHour;
  }
};
